import { config as categoryConfig, getTemplateNameByPath as getCategoryTemplateNameByPath } from '~/assets/services/category';

const { pageType: categoryPageType } = categoryConfig;

export default {
    [categoryPageType]({ path }) {
        return getCategoryTemplateNameByPath({ path });
    },
};
